import { create } from "zustand";

interface LoadingState {
  isLoading: boolean;
  message?: string;
  setLoading: (loading: boolean, message?: string) => void;
}

const useLoadingStore = create<LoadingState>((set) => ({
  isLoading: false,
  message: undefined,
  setLoading: (loading, message) =>
    set({
      isLoading: loading,
      message: loading ? message : undefined,
    }),
}));

export default useLoadingStore;
